(function () {
  'use strict';
  let controller;
  let priceTimer;

  function paramsFromForm(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (String(value).trim()) params.append(key, value);
    });
    return params;
  }

  async function render(url, sectionId, pushState) {
    const shell = document.getElementById('ShopResults');
    if (!shell) {
      window.location.assign(url);
      return;
    }
    if (controller) controller.abort();
    const requestController = new AbortController();
    controller = requestController;
    shell.classList.add('is-loading');
    document.body.classList.add('is-loading');
    document.querySelectorAll('[data-facets-form] button[type="submit"]').forEach((button) => {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Aggiornamento…';
    });

    try {
      const requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('section_id', sectionId);
      const response = await fetch(requestUrl.toString(), { signal: requestController.signal });
      if (!response.ok) throw new Error(String(response.status));
      const text = await response.text();
      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const replacement = parsed.getElementById('ShopResults');
      if (!replacement) throw new Error('Missing section response');
      const currentShell = document.getElementById('ShopResults');
      if (!currentShell) throw new Error('Missing current results');
      currentShell.replaceWith(replacement);
      if (pushState) history.pushState({}, '', url);
      document.dispatchEvent(new CustomEvent('gommadot:content-updated', { detail: replacement }));
      const count = replacement.dataset.resultCount;
      if (window.GommaDotTheme && count) window.GommaDotTheme.announce(`${count} risultati`);
      const resultsHeading = replacement.querySelector('.shop-toolbar__count');
      if (resultsHeading) resultsHeading.setAttribute('tabindex', '-1');
      if (window.GommaDotTheme) window.GommaDotTheme.closeMobileFacets();
      if (resultsHeading && window.matchMedia('(max-width: 1023px)').matches) resultsHeading.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(url);
    } finally {
      if (controller === requestController) {
        controller = null;
        document.body.classList.remove('is-loading');
      }
    }
  }

  function submitForm(form) {
    const params = paramsFromForm(form);
    const url = `${form.action}${params.toString() ? `?${params.toString()}` : ''}`;
    render(url, form.dataset.sectionId, true);
  }

  function usesMobileDrawer(form) {
    return window.matchMedia('(max-width: 1023px)').matches && Boolean(form.closest('.shop-sidebar'));
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-facets-form]');
    if (!form) return;
    event.preventDefault();
    submitForm(form);
  });

  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-facets-form]');
    if (form) {
      if (usesMobileDrawer(form)) return;
      if (event.target.type === 'number') {
        window.clearTimeout(priceTimer);
        priceTimer = window.setTimeout(() => submitForm(form), 500);
      } else {
        submitForm(form);
      }
      return;
    }

    const sort = event.target.closest('[data-sort-select]');
    if (sort) {
      const url = new URL(sort.dataset.resultsUrl || window.location.href);
      url.searchParams.set('sort_by', sort.value);
      render(url.toString(), sort.dataset.sectionId, true);
    }
  });

  window.addEventListener('popstate', () => window.location.reload());
})();
